export const secretKey = "dgsd5sd&65adgasd65ga&dgdfg54fgd@fgdsdf4";
